import './ClassLessons.scss'

import { DeleteOutlined, SearchOutlined } from '@ant-design/icons'
import {Button, Col, Input, Modal, notification, Row, Select, Table} from 'antd'
import DeleteModal from 'components/okulyonetim-admin/delete-modal/DeleteModal'
import { saveAs } from 'file-saver'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import * as XLSX from 'xlsx'

import AppContext from '../../../../context/AppContext'
import { useOkulSinifDersleriQuery, useSinifDersiSilMutation } from '../../../../gql/GeneratedGraphqlTypes'
import Spinner from '../../../spinner/Spinner'
import { ReactComponent as AktarIcon } from '../okul-siparis-page/icons/aktar.svg'

const { Option } = Select
const { Search } = Input

const ClassLessons: React.FC = () => {
  const navigate = useNavigate()
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [searchValue, setSearchValue] = useState<string>('')
  const [selectedDurum, setSelectedDurum] = useState<string | undefined>(undefined)
  const [selectedOgretmen, setSelectedOgretmen] = useState<string | undefined>(undefined)
  const [selectedDers, setSelectedDers] = useState<string | undefined>(undefined)
  const [modalMessage, setModalMessage] = useState<string[]>([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalTitle, setModalTitle] = useState('')
  const { okul } = useContext(AppContext)
  const [sinifDersleriSil] = useSinifDersiSilMutation()
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const { data, loading, refetch, error } = useOkulSinifDersleriQuery({
    variables: {
      sube_id: okul?.id,
      arama: searchValue || null,
      sinif_id: selectedDurum ?? null,
      ders_id: selectedDers ?? null,
      ogretmen_id: selectedOgretmen ?? null,
    },
    fetchPolicy: 'network-only',
  })
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false)
  const [deleteId, setDeleteId] = useState<string | null>(null)

  const showDeleteModal = (ids: string[]) => {
    setDeleteId(ids.join(','))
    setIsDeleteModalVisible(true)
  }

  const handleDelete = async (ids: string) => {
    const idList: number[] = ids.split(',').map((id) => Number(id))
    try {
      const response = await sinifDersleriSil({
        variables: {
          id: idList,
        },
      })
      if (response.data?.sinifDersiSil.success) {
        notification.success({
          message: '',
          description: `${response.data?.sinifDersiSil?.message}`,
          duration: 6,
        })
        setIsDeleteModalVisible(false)
        setSelectedRowKeys([])

        await refetch()
      } else {
        setModalTitle('Silinemeyen Sınıf Dersleri')

        setIsModalOpen(true)
        const silinenler = response.data?.sinifDersiSil?.silinenler?.map((item) => `✅ Silindi: ${item?.isim}`) ?? []

        const silinemeyenler =
            response.data?.sinifDersiSil?.silinemeyenler?.map((item) => {
              const nedenMesaji = item?.neden?.length
                  ? item.neden
                      .map((neden) => {
                        const urunIdMatch = /Ürün ID: (\d+)/.exec(neden!)
                        const urunId = urunIdMatch?.[1]
                        //     < a
                        // href = "/v1/okulyonetimadmin/dersurunu/"
                        // rel = "noopener noreferrer" >
                        if (urunId) {
                          return `❌${neden}`
                        }

                        return `❌ ${neden}`
                      })
                      .join('<br/>')
                  : ''

              return nedenMesaji
            }) ?? []
        setModalMessage([...silinenler, ...silinemeyenler])
      }
    } catch (error) {
      notification.error({
        message: '',
        description: 'Listeyi gönderirken bir hata oluştu.',
        duration: 6,
      })
    }
  }
  // Filtreleme değiştikçe veriyi tekrar çek
  useEffect(() => {
    refetch()
  }, [searchValue, selectedDurum, refetch])

  const handleSearch = () => {
    setSearchValue(searchTerm)
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }
  if (loading) {
    return <Spinner showSpinner={loading} color="red" />
  }

  if (error) {
    console.error(error)
    navigate('/')
    return null
  }
  const handleFilterChange = (filterType: 'durum' | 'ogretmen' | 'ders',  value: string | undefined) => {
    if (value === null) {
      if (filterType === 'durum') setSelectedDurum(value)
      if (filterType === 'ogretmen') setSelectedOgretmen(value)
      if (filterType === 'ders') setSelectedDers(value)
    } else {
      if (filterType === 'durum') setSelectedDurum(value)
      if (filterType === 'ogretmen') setSelectedOgretmen(value)
      if (filterType === 'ders') setSelectedDers(value)
    }
  }

  const filteredData = data?.okulSinifDersleri?.sinif_dersleri?.filter(Boolean) ?? []
  const totalItems = filteredData.length
  const displayedItems = selectedRowKeys.length
  const siniflarOptions = [
    <Option key="tum" value={null}>
      Tümü
    </Option>, // 🔹 "Tümü" seçeneği eklendi
    ...(data?.okulSinifDersleri?.siniflar?.map((durum) => (
      <Option key={durum?.id} value={durum?.id}>
        {durum?.isim}
      </Option>
    )) || []),
  ]

  const derslerOptions = [
    <Option key="tum" value={null}>
      Tümü
    </Option>, // 🔹 "Tümü" seçeneği eklendi
    ...(data?.okulSinifDersleri?.dersler?.map((durum) => (
      <Option key={durum?.id} value={durum?.id}>
        {durum?.isim}
      </Option>
    )) || []),
  ]

  const ogretmenlerOptions = [
    <Option key="tum" value={null}>
      Tümü
    </Option>, // 🔹 "Tümü" seçeneği eklendi
    ...(data?.okulSinifDersleri?.ogretmenler?.map((durum) => (
      <Option key={durum?.id} value={durum?.id}>
        {durum?.isim}
      </Option>
    )) || []),
  ]

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      sorter: (a: any, b: any) => a.id - b.id,
      defaultSortOrder: 'descend' as 'descend' | 'ascend' | undefined,
    },

    { title: 'Sinif', dataIndex: 'sinif', key: 'sinif' },
    { title: 'Ders', dataIndex: 'ders', key: 'ders' },
    { title: 'Öğretmen', dataIndex: 'ogretmen', key: 'ogretmen' },
    {
      title: '',
      key: 'detail',
      render: (record: any) => (
        <Button
          className="okul-yonetim-admin-detail-button"
          onClick={() => navigate(`/okulyonetimadmin/sinifdersi/${record.id}`)}
        >
          Detay
        </Button>
      ),
    },
  ]
  const exportAllToExcel = () => {
    const worksheetData: any[] = []

    const headers = ['id','sinif_id', 'sinif_adi', 'ders_id','ders_adi,','ogretmen_id', 'ogretmen_adi','ogretmen_soyadi','ogretmen_mail' ]
    worksheetData.push(headers)

    data?.okulSinifDersleri?.sinif_dersleri.forEach((sinifDersler: any) => {
      const transformedData = [sinifDersler.id,sinifDersler.sinif_id || '',sinifDersler.sinif, sinifDersler.ders_id || '', sinifDersler.ders, sinifDersler.ogretmen_id || '', sinifDersler.ogretmen_adi, sinifDersler.ogretmen_soyadi, sinifDersler.ogretmen_mail]
      worksheetData.push(transformedData)
    })

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)

    const colWidths = worksheetData[0].map((_: string, colIndex: number) =>
      Math.max(...worksheetData.map((row) => (row[colIndex] ? row[colIndex].toString().length : 10))),
    )
    worksheet['!cols'] = colWidths.map((width: number) => ({ wch: width }))

    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'TümVeriler')
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
    saveAs(new Blob([excelBuffer]), `sinifDersler.xlsx`)
  }
  return (
    <div className="okul-sinif-dersi-page">
      <div className="okul-sepeti-admin-header">
        <h1>Sınıf Dersleri </h1>
        <div className="export-buttons">
          <Button onClick={exportAllToExcel} className="export-button">
            <AktarIcon /> Dışa Aktar{' '}
          </Button>
          <Button onClick={() => navigate('/okulyonetimadmin/sinifdersi/ice-aktar')} className="export-button">
            <AktarIcon /> İçe Aktar
          </Button>
        </div>
      </div>
      <Row justify={'space-between'} className="filter-section">
        <Col span={6}>
          <Search
            placeholder="Sınıf Dersi Ara"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onSearch={handleSearch}
            allowClear
            enterButton={
              <div className="search-suffix-div">
                Ara <SearchOutlined />{' '}
              </div>
            }
          />
        </Col>
        <Col span={4}>
          <Select
            placeholder="Sınıflar"
            value={selectedDurum}
            onChange={(value) => handleFilterChange('durum', value)}
            allowClear
          >
            {siniflarOptions}
          </Select>
        </Col>
        <Col span={4}>
          <Select
            placeholder="Öğretmenler"
            value={selectedOgretmen}
            onChange={(value) => handleFilterChange('ogretmen', value)}
            allowClear
          >
            {ogretmenlerOptions}
          </Select>
        </Col>
        <Col span={4}>
          <Select
            placeholder="Dersler"
            value={selectedDers}
            onChange={(value) => handleFilterChange('ders', value)}
            allowClear
          >
            {derslerOptions}
          </Select>
        </Col>
        {/*//todo: range ile tarih te eklenmeli*/}
        {/*<Col span={6}>*/}
        {/*    <RangePicker value={dateRange} onChange={handleDateChange} format="YYYY-MM-DD" />*/}
        {/*</Col>*/}
        <div className="button-right">
          <Button onClick={() => navigate('/okulyonetimadmin/sinifdersi/sinif-dersi-ekle')}>Sınıf Dersi Ekle</Button>
        </div>
      </Row>

      <Table
        dataSource={filteredData as object[]}
        columns={columns}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
          total: totalItems,
          showTotal: (total) => (
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <Button
                style={{
                  display: selectedRowKeys.length === 0 ? 'none' : '',
                }}
                icon={<DeleteOutlined />}
                onClick={() => showDeleteModal(selectedRowKeys.map((id) => id.toString()))}
                type="primary"
                danger
              >
                Seçilen {selectedRowKeys.length} Sınıf Deslerini Sil
              </Button>

              <span style={{ marginLeft: '10px' }}>
                {' '}
                {/* Buton ile metin arasına boşluk koyuyoruz */}
                Seçilen: {displayedItems} / Toplam: {total}
              </span>
            </div>
          ),
          onChange: (page, size) => {
            setCurrentPage(page)
            setPageSize(size)
          },
        }}
        rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-light' : 'table-row-dark')}
        loading={loading}
        rowKey="id"
        className="okul-yonetim-admin-table"
        rowSelection={{
          type: 'checkbox',
          selectedRowKeys,
          onChange: (keys) => setSelectedRowKeys(keys as string[]),
          ...Selection,
        }}
      />
      <DeleteModal
        title="Seçilen Sınıf Derslerini Sil"
        id={deleteId || ''}
        visible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onDelete={handleDelete}
      />
      <Modal
          footer={<Button onClick={handleCancel}>Kapat</Button>}
          onCancel={handleCancel}
          title={modalTitle}
          open={isModalOpen}
      >
        <ul>
          {modalMessage.map((message, index) => (
              <li key={index} dangerouslySetInnerHTML={{__html: message}}/>
          ))}
        </ul>
      </Modal>
    </div>
  )
}

export default ClassLessons
